import React from "react";
import "./Notification.css";

function Notification(props) {


    if(props.notificationStatus.current == true){
        return (
            <div className="Notification">TAP THE GREEN SQUARE</div>
        );
    } else {
        return (
            <div className="Notification" style={{display:'none'}}>HIDE NOTIFICATION</div>
        );
    }


}

export default Notification;
